const ambassador = () => `
  (function (u, n, i, v, e, r, s, a, l) {u[r] = {}; u[r].uid = '21ef6cd7-9d90-4b7a-a1c3-6977697ddefd';a = n.createElement(v); a.src = e; a.async = s;n.getElementsByTagName(i)[0].appendChild(a);})(window, document, 'head', 'script', 'https://cdn.getambassador.com/us.js', 'mbsy', true);
`;

export default ambassador;
